export default __webpack_public_path__ + "static/media/019-ceuta.942375fd.svg";